import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClientCredentialsTokenService {
  public token: string;

  setToken(token: string) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }

  removeToken() {
    this.token = null;
  }
}
